import { IUser } from './../../common/types/User'
import { InputLoja } from './../../common/types/Loja'
import { éCargoAdminDeLoja } from './../../common/shareds/utils'
import { userModule } from '@/store'

export function criarLoja(): InputLoja {
	const usuario = userModule.currentUser
	if (!usuario) throw new Error('Usuário não logado')
	if (usuario.role === 'Visitante') throw new Error('Visitante não pode criar loja')
	if (!usuario.somar) throw new Error('Usuário sem somar não pode criar loja')

	return {
		nome: '',
		somar: usuario.somar._id,
		potencia: '',
		endereco: '',
		compromissosDoApp: {
			agendaDeSessoes: false,
			dadosDosIrmaos: false,
			candidatosDaLoja: false,
		},
		oficial: true,
	}
}
//valida se o usuário atual é admin da loja ou não
export const adminLojaGuard = (idLoja: string | null) =>
	(user: IUser | null) =>
		!!user && user.role !== 'Visitante' && (
			(user.loja._id === idLoja && éCargoAdminDeLoja(user.cargoDeAdminDaLoja, user.secretarioDeInformatica)) ||
			user.lojas.some(loja => loja.loja._id === idLoja && éCargoAdminDeLoja(loja.cargoDeAdminDaLoja))
		)
	
export const storageLogoLojaRef = process.env.NODE_ENV === 'production'
	? 'logo-lojas'
	: 'logo-lojas-dev'
